module.exports = __webpack_public_path__ + "assets/img/2861.26a718ac.svg";